var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkplaceGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 600,
    viewBox: "0 0 1000 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M368.538 424.787L390.452 380.963H579.162L600.468 424.792",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M442.2 391.307H399.212L383.148 424.788",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M394.235 402.53H437.629",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M388.474 413.685H417.845",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M410.143 391.307L397.453 419.613",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M420.465 391.491L414.378 406.725",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M636.001 117.982H368.311C361.04 117.982 355.145 123.877 355.145 131.148V313.614C355.145 320.885 361.04 326.78 368.311 326.78H636.001C643.272 326.78 649.167 320.885 649.167 313.614V131.148C649.167 123.877 643.272 117.982 636.001 117.982Z",
    fill: "#CDD9E2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M632.731 133.809H371.581V301.782H632.731V133.809Z",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M477.5 322.519C477.5 322.519 482.675 352.819 454.422 363.168H551.767C551.767 363.168 523.628 353.568 525.454 322.519",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M670 303H825",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M181 304L336 304",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M158.1 389.944L165.1 383.512L167.056 391.137L162.792 395.054",
    fill: "#CDD9E2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M104.062 453.87L165.728 397.228L156.483 387.163L94.8163 443.804L104.062 453.87Z",
    fill: "#CDD9E2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M118.86 440.277L109.615 430.211",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M908.2 366.595L989.569 464.771H777.5L739.786 451L681.518 366.563L908.2 366.595Z",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M719.744 382.156L767.911 446.556H947.267L894.8 382.037L719.744 382.156Z",
    fill: "#CDD9E2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M836.523 379.269L860.223 408.594H825.093",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M868.178 419.426L894.891 452.485",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M732.791 408.594H799.425",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M719.214 506.79L683.384 431.223L837.4 486.194L719.214 506.79Z",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M711.977 455.801L728.477 490.601L784.183 480.957L711.977 455.801Z",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M724.084 506.108L722.043 501.801",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M744.453 502.321L742.435 498.061",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M764.855 498.6L762.86 494.387",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M785.288 494.946L783.317 490.78",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M805.756 491.36L803.808 487.24",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M734.265 504.206L730.475 496.208",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M754.649 500.453L750.903 492.542",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M775.068 496.766L771.365 488.943",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M795.518 493.145L791.859 485.409",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M816.003 489.591L812.387 481.943",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M826.257 487.839L824.332 483.766",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M261.054 402.45L205.137 397.894L212.876 385.375L267.843 389.931L261.054 402.45Z",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M205.829 414.102L195.582 413.28L201.07 404.452L211.196 405.274L205.829 414.102Z",
    fill: "#B4C5D0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M221.978 415.394L211.695 414.572L216.995 405.744L227.157 406.566L221.978 415.394Z",
    fill: "#B4C5D0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M237.3 416.615L226.983 415.793L232.1 406.963L242.3 407.785L237.3 416.615Z",
    fill: "#B4C5D0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M252.667 417.836L242.317 417.014L247.256 408.186L257.485 409.008L252.667 417.836Z",
    fill: "#B4C5D0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M197.981 426.963L187.558 426.141L193.069 417.313L203.369 418.135L197.981 426.963Z",
    fill: "#B4C5D0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M214.406 428.257L203.947 427.435L209.268 418.607L219.606 419.429L214.406 428.257Z",
    fill: "#B4C5D0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M229.987 429.478L219.494 428.656L224.635 419.828L235.007 420.65L229.987 429.478Z",
    fill: "#B4C5D0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M245.618 430.7L235.092 429.878L240.054 421.05L250.459 421.872L245.618 430.7Z",
    fill: "#B4C5D0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M190.1 439.829L179.5 439.007L185.034 430.179L195.513 431.001L190.1 439.829Z",
    fill: "#B4C5D0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M206.8 441.121L196.165 440.299L201.509 431.471L212.023 432.293L206.8 441.121Z",
    fill: "#B4C5D0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M222.644 442.342L211.975 441.52L217.139 432.692L227.687 433.514L222.644 442.342Z",
    fill: "#B4C5D0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M238.536 443.563L227.836 442.741L232.821 433.913L243.403 434.735L238.536 443.563Z",
    fill: "#B4C5D0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M181.95 453.071L171.169 452.249L176.726 443.421L187.386 444.243L181.95 453.071Z",
    fill: "#B4C5D0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M198.937 454.363L188.121 453.541L193.488 444.713L204.188 445.535L198.937 454.363Z",
    fill: "#B4C5D0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M215.049 455.584L204.2 454.763L209.388 445.935L220.117 446.757L215.049 455.584Z",
    fill: "#B4C5D0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M231.211 456.805L220.327 455.983L225.335 447.155L236.098 447.977L231.211 456.805Z",
    fill: "#B4C5D0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M206.865 378.318L154 458.863L153.681 467.095L235.501 473.876L282.367 392.925L282.703 384.234L206.869 378.323",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M436.96 201.376L484.8 179.467L539.628 195.876L539.341 215.804L569.317 223.747L569.604 243.537L521.704 265.41L436.96 241.216V201.376Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M436.907 241.293L521.853 265.486",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M484.91 219.517L569.856 243.718",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M436.907 241.293L484.807 219.412",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M436.907 221.597L484.807 201.885",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M436.96 241.216V201.058",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M492.23 237.129V217.483",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M484.808 219.412V179.276",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M436.907 201.135L460.857 190.298",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M460.851 190.298L484.801 179.467",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M436.96 221.334L521.719 245.547",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M436.96 201.376L492.23 217.483",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M484.797 179.676L540.067 195.787",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M569.606 223.752L521.719 245.547",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M484.808 201.885L539.63 216.027",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 3"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M492.23 217.482L539.63 195.876",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M539.629 195.876V216.027",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M521.705 245.548V265.41",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M521.705 265.41L569.605 243.537",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M569.605 223.752V243.385",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M539.343 215.804L569.319 223.747",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M492.23 237.129L539.343 215.804",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M641.359 375.298C641.359 375.298 625.459 375.298 625.459 393.692V408.792C625.459 408.792 627.359 426.044 641.359 426.044C654.214 426.044 657.935 413.866 658.273 409.807C658.611 405.748 658.823 393.379 658.823 393.379C658.823 393.379 660.218 375.298 641.359 375.298Z",
    fill: "#B4C5D0"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M641.926 395.341V374.791C641.926 371.841 641.181 368.429 638.367 366.9C634.377 364.732 629.149 366.216 624.881 366.458C619.826 366.745 614.281 367.073 609.498 365.114C604.484 363.062 601.689 358.398 601.049 353.14C600.6 349.452 600.59 345.012 603.032 341.945C604.499 340.103 607.18 338.545 609.57 339.318C610.604 339.636 611.487 340.319 612.055 341.24C612.623 342.16 612.836 343.256 612.655 344.323C611.984 347.677 608.774 352.623 596.82 354.155C583.652 355.844 575.509 349.927 575.509 349.927C575.509 349.927 560.962 339.44 563.838 323.033",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M622.644 395.341H662.281",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkplaceGrey);
export default __webpack_public_path__ + "static/media/workplace_grey.254423cdc9127243b8ff1d6797b60bdc.svg";
export { ForwardRef as ReactComponent };